/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { organisationRemoveOwner } from '../../axios/organisationRemoveOwner'
import type {
	OrganisationRemoveOwnerError,
	OrganisationRemoveOwnerPathParams,
	OrganisationRemoveOwnerResponse,
} from '../../types/OrganisationRemoveOwner'

export const organisationRemoveOwnerMutationKey = () => [{ url: '/organisations/:organisation/owner' }] as const

export type OrganisationRemoveOwnerMutationKey = ReturnType<typeof organisationRemoveOwnerMutationKey>

export type OrganisationRemoveOwnerVariables = {
	organisation: OrganisationRemoveOwnerPathParams['organisation']
}

/** @see backend/nexus/modules/Organisation/Http/Controllers/OrganisationController.php OrganisationController::removeOwner */
export function useOrganisationRemoveOwner<TContext = unknown>(
	options?: UseMutationOptions<
		OrganisationRemoveOwnerResponse,
		AxiosError<OrganisationRemoveOwnerError>,
		OrganisationRemoveOwnerVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: organisationRemoveOwnerMutationKey(),
		mutationFn: ({ organisation }: OrganisationRemoveOwnerVariables) =>
			organisationRemoveOwner(organisation, config).then(res => res.data),
		...options,
	})
}
